(function () {
  "use strict";

  var config = window.AuroraEducation;
  if (!config || !config.assetUrl) return;

  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s || "";
    return d.innerHTML;
  }

  function loadCatalog() {
    return fetch(config.assetUrl).then(function (r) {
      if (!r.ok) throw new Error("Failed to load education data");
      return r.json();
    });
  }

  function initHub(catalog) {
    var grid = document.querySelector("[data-education-grid]");
    var filters = document.querySelector("[data-education-filters]");
    var search = document.querySelector("[data-education-search]");
    if (!grid) return;

    var categories = ["All"].concat(catalog.categories || []);
    var activeCategory = "All";
    var query = "";

    if (search) {
      search.addEventListener("input", function () {
        query = search.value.trim();
        if (window.location.hash) {
          window.location.hash = "";
        } else {
          renderGrid();
        }
      });
    }

    function renderFilters() {
      filters.innerHTML = categories.map(function (cat) {
        var active = cat === activeCategory ? " is-active" : "";
        return '<button type="button" class="education-filter' + active + '" data-cat="' + esc(cat) + '">' + esc(cat) + "</button>";
      }).join("");

      filters.querySelectorAll("[data-cat]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          activeCategory = btn.getAttribute("data-cat");
          renderFilters();
          renderGrid();
        });
      });
    }

    function filtered() {
      return catalog.entries.filter(function (e) {
        var matchCat = activeCategory === "All" || e.category === activeCategory;
        var q = query.toLowerCase();
        var matchQ = !q || (e.title + " " + e.summary + " " + e.category).toLowerCase().indexOf(q) >= 0;
        return matchCat && matchQ;
      });
    }

    function renderGrid() {
      var items = filtered();
      if (!items.length) {
        grid.innerHTML = '<p class="text-muted">No guides match your search.</p>';
        return;
      }
      grid.innerHTML = items.map(function (e) {
        return (
          '<a href="/pages/education#' + esc(e.handle) + '" class="education-card reveal is-visible" data-edu-card="' + esc(e.handle) + '">' +
          '<span class="education-card__cat">' + esc(e.category) + "</span>" +
          "<h3>" + esc(e.title) + "</h3>" +
          '<p class="text-muted">' + esc(e.summary) + "</p>" +
          '<span class="education-card__link">Read guide &rarr;</span></a>'
        );
      }).join("");
    }

    function renderDetail(entry) {
      grid.innerHTML =
        '<div class="education-detail reveal is-visible">' +
        '<a href="/pages/education" class="text-muted education-detail__back">&larr; All guides</a>' +
        '<span class="eyebrow">' + esc(entry.category) + "</span>" +
        "<h2>" + esc(entry.title) + "</h2>" +
        '<p class="text-muted">' + esc(entry.summary) + "</p>" +
        '<div class="education-guide__grid" style="margin-top:24px; padding-top:24px; border-top:1px solid var(--border);">' +
        '<div class="education-guide__main">' +
        "<h3>Overview</h3><p>" + esc(entry.overview) + "</p>" +
        "<h3>Mechanism of action</h3><p>" + esc(entry.mechanism) + "</p>" +
        "<h3>Research areas</h3><ul class=\"education-tags\">" +
        entry.researchAreas.map(function (a) { return "<li>" + esc(a) + "</li>"; }).join("") +
        "</ul></div>" +
        '<aside class="education-guide__aside">' +
        '<div class="education-aside-card"><h3>Shop this compound</h3>' +
        '<p class="text-muted">' + esc(entry.summary) + '</p>' +
        '<a href="' + esc(entry.productUrl) + '" class="btn btn--primary btn--block">View product</a></div></aside></div></div>';
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    function checkHash() {
      var hash = (window.location.hash || "").replace("#", "");
      if (!hash) {
        renderFilters();
        renderGrid();
        return;
      }
      var entry = catalog.entries.find(function (e) { return e.handle === hash; });
      if (entry) renderDetail(entry);
      else renderGrid();
    }

    window.addEventListener("hashchange", checkHash);
    checkHash();
  }

  function initGuide(catalog) {
    var handle = config.guideHandle;
    var entry = catalog.entries.find(function (e) { return e.handle === handle; });
    if (!entry) return;

    var cat = document.querySelector("[data-edu-category]");
    var title = document.querySelector("[data-edu-title]");
    var summary = document.querySelector("[data-edu-summary]");
    var overview = document.querySelector("[data-edu-overview]");
    var mechanism = document.querySelector("[data-edu-mechanism]");
    var areas = document.querySelector("[data-edu-areas]");
    var asideSummary = document.querySelector("[data-edu-aside-summary]");
    var productLink = document.querySelector("[data-edu-product-link]");

    if (cat) cat.textContent = entry.category;
    if (title) title.textContent = entry.title;
    if (summary) summary.textContent = entry.summary;
    if (overview) overview.textContent = entry.overview;
    if (mechanism) mechanism.textContent = entry.mechanism;
    if (asideSummary) asideSummary.textContent = entry.summary;
    if (productLink) {
      productLink.href = entry.productUrl;
      productLink.textContent = "View " + entry.title;
    }
    if (areas && entry.researchAreas) {
      areas.innerHTML = entry.researchAreas.map(function (a) {
        return "<li>" + esc(a) + "</li>";
      }).join("");
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    loadCatalog()
      .then(function (catalog) {
        if (config.hubMode) initHub(catalog);
        else initGuide(catalog);
      })
      .catch(function () {
        var grid = document.querySelector("[data-education-grid]");
        if (grid) grid.innerHTML = "<p class=\"text-muted\">Unable to load education catalog.</p>";
      });
  });
})();
